class SearchTypingAnimator {
  constructor(baseSelector, headingSelector, inputSelector) {
    this.baseSpan = document.querySelector(baseSelector);
    this.headingSpan = document.querySelector(headingSelector);
    this.inputField = document.querySelector(inputSelector); // Add input field selector

    if (!this.baseSpan || !this.headingSpan || !this.inputField) {
      console.error("❌ One or more elements not found!");
      return;
    }

    const data = document.querySelector('[data-active-search]');
    this.words = data?.dataset?.activeSearch?.split(',') || [];
    this.words = this.words.map(item => item.trim()).filter(Boolean);
    // With no words, animateWordLoop never reaches its end condition and would tick forever
    if (!this.words.length) return;

    this.baseText = "Search for ";
    this.init();
  }

  init() {
    // Reset everything to loop correctly
    this.currentWordIndex = 0;
    this.charIndex = 0;
    this.isDeleting = false;
    this.showFullText = true; // Show full text initially
    this.start();
  }

  async start() {
    await this.typeBaseText();
    this.animateWordLoop();
  }

  typeBaseText() {
    return new Promise((resolve) => {
      let i = 0;
      const interval = setInterval(() => {
        const text = this.baseText.slice(0, i + 1);
        this.baseSpan.textContent = text;
        this.inputField.placeholder = text; // Update input placeholder
        i++;
        if (i > this.baseText.length) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  deleteBaseText() {
    return new Promise((resolve) => {
      let i = this.baseText.length;
      const interval = setInterval(() => {
        const text = this.baseText.slice(0, i);
        this.baseSpan.textContent = text;
        this.inputField.placeholder = text; // Update input placeholder
        i--;
        if (i <= 0) {
          clearInterval(interval);
          resolve();
        }
      }, 80);
    });
  }

  animateWordLoop() {
    const currentWord = this.words[this.currentWordIndex];
    const fullText = `${this.baseText}<b>${currentWord}</b>`;
    const onlyBold = `<b>${currentWord}</b>`;
    const targetText = this.showFullText ? fullText : onlyBold;

    if (!this.isDeleting) {
      this.charIndex++;
      const text = currentWord.substring(0, this.charIndex);
      this.headingSpan.innerHTML = text;
      this.inputField.placeholder = this.showFullText
        ? `${this.baseText}${text}`
        : `${this.baseText}${text}`;

      if (this.charIndex === currentWord.length) {
        setTimeout(() => {
          this.isDeleting = true;
          this.animateWordLoop();
        }, 1000);
        return;
      }
    } else {
      this.charIndex--;
      const text = currentWord.substring(0, this.charIndex);
      this.headingSpan.innerHTML = text;
      this.inputField.placeholder = this.showFullText
        ? `${this.baseText}${text}`
        : `${this.baseText}${text}`;

      if (this.charIndex === 0) {
        if (this.currentWordIndex === this.words.length - 1) {
          // After last word deleted, delete base and restart
          this.deleteBaseText().then(() => {
            this.headingSpan.innerHTML = "";
            this.inputField.placeholder = "";
            this.showFullText = true; // Show full text again after loop
            this.init(); // Restart the full cycle
          });
          return;
        }

        this.isDeleting = false;
        this.currentWordIndex++;
        this.showFullText = false; // Only show bold text for subsequent words
      }
    }

    const delay = this.isDeleting ? 60 : 100;
    setTimeout(() => this.animateWordLoop(), delay);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const scope = '.header__quick-search-bar .quick-search__bar.data-active-search ';
  const start = () => new SearchTypingAnimator(
    scope + '[data-quick-search-faux-text]',
    scope + '[data-quick-search-faux-heading]',
    '#QuickSearchInputmobile' // Add the input field selector
  );

  // The animation runs forever (timers + DOM/placeholder writes every 60-100ms), so only
  // start it once the search bar is actually rendered. When it is visible on load the
  // observer fires on the first layout, so timing is unchanged; a hidden bar never animates.
  const fauxInput = document.querySelector(scope + '[data-quick-search-faux-input]');
  if (!fauxInput || !('ResizeObserver' in window)) {
    start();
    return;
  }
  const observer = new ResizeObserver((entries) => {
    const rect = entries[0].contentRect;
    if (rect.width > 0 && rect.height > 0) {
      observer.disconnect();
      start();
    }
  });
  observer.observe(fauxInput);
});
